import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body">
						<div className="work">
							<img
								src="./Carestream.png"
								alt="Carestream Dental"
								className="work-image"
							/>
							<div className="work-text">
								<div className="work-title">Carestream Dental</div>
								<div className="work-subtitle">Engineer</div>
							</div>
							<div className="work-duration">2019 - 2022</div>
						</div>

						<div className="work">
							<img
								src="./IDI.png"
								alt="Innovative Document Imaging"
								className="work-image"
							/>
							<div className="work-text">
								<div className="work-title">Innovative Document Imaging</div>
								<div className="work-subtitle">IT Manager</div>
							</div>
							<div className="work-duration">2017 - 2019</div>
						</div>

						<div className="work">
							<img
								src="./CW.png"
								alt="Challenges Worldwide"
								className="work-image"
							/>
							<div className="work-text">
								<div className="work-title">Challenges Worldwide</div>
								<div className="work-subtitle">Volunteer Consultant</div>
							</div>
							<div className="work-duration">2016 - 2017</div>
						</div>

						<div className="work">
							<img
								src="./PSI.png"
								alt="PSI International"
								className="work-image"
							/>
							<div className="work-text">
								<div className="work-title">PSI International</div>
								<div className="work-subtitle">Systems Administrator</div>
							</div>
							<div className="work-duration">2014 - 2016</div>
						</div>

						<div className="work">
							<img
								src="./SL.png"
								alt="ServiceLine"
								className="work-image"
							/>
							<div className="work-text">
								<div className="work-title">ServiceLine</div>
								<div className="work-subtitle">Systems Analyst</div>
							</div>
							<div className="work-duration">2013 - 2014</div>
						</div>

						<div className="work">
							<img
								src="./Serco.png"
								alt="Serco Global"
								className="work-image"
							/>
							<div className="work-text">
								<div className="work-title">Serco Global</div>
								<div className="work-subtitle">Service Desk Analyst</div>
							</div>
							<div className="work-duration">2012 - 2013</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;